import { createAsyncThunk } from '@reduxjs/toolkit';

import {
  IUserAvailability,
  TUserAvailabilitySlotOption,
  TUserAvailabilitySlotOptionsData,
} from '.';
import { AdminApiPaths } from '../../../api/APIPaths';
import APIDataProvider, { TApiResponse } from '../../../api/ApiDataProvider';

export type TUpdateuserAvailabilityAsAdmin = {
  userId: string;
  slots: IUserAvailability['slots'];
};

export type TGetUserAvailabilitySlotsAdmin = {
  userId: string;
  sectionId: string;
  date: string;
  duration: number;
};

type TGetTutorAvailabilitySlots = {
  student: string;
  curriculum: string;
  subject: string;
  grade: string;
  date: string;
  tutor?: string;
};

const apiDataProvider = new APIDataProvider();

export const updateUserAvialabilityAsAdmin = createAsyncThunk(
  '/admin/user-availability/update',
  async ({ userId, ...data }: TUpdateuserAvailabilityAsAdmin) => {
    const path = `${AdminApiPaths.userAvailability}/${userId}`;
    const response = await apiDataProvider.put<TApiResponse<IUserAvailability>>(
      path,
      data
    );

    return response.data;
  }
);

export const getUserAvialabilityDataByUserIdAsAdmin = createAsyncThunk(
  '/admin/user-availability/getOneByUserId',
  async (userId: string) => {
    const path = `${AdminApiPaths.userAvailability}/${userId}`;
    const response = await apiDataProvider.get<TApiResponse<IUserAvailability>>(
      path
    );

    return response.data;
  }
);

export const getUserAvailabilitySlotOptionsDataAsAdmin = createAsyncThunk(
  '/admin/user-availability/slots/userId',
  async (data: TGetUserAvailabilitySlotsAdmin) => {
    const path = `${AdminApiPaths.userAvailability}/slots/${data.userId}?date=${data.date}&userId=${data.userId}&sectionId=${data.sectionId}&duration=${data.duration}`;

    const response = await apiDataProvider.get<
      TApiResponse<TUserAvailabilitySlotOptionsData>
    >(path);

    return response.data;
  }
);

export const getUserAvailabilitySlotsForTrialAsAdmin = createAsyncThunk(
  '/admin/user-availability/slots/trial',
  async (data: TGetTutorAvailabilitySlots) => {
    const path = `${AdminApiPaths.userAvailability}/slots/trial`;

    const response = await apiDataProvider.post<
      TApiResponse<TUserAvailabilitySlotOption[]>
    >(path, data);

    return response.data;
  }
);
